<style>
/* @import "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css"; */
#main {
  float: left;
  text-align: left;
  width: 100%;
  padding: 30px;
}
p{
  margin: 0;
}
#pcgateway{
  margin-right:10px;
}
</style>
<template>
  <div class="ConnectDevice">
    <div class="container">
      <div class="main" id="main">
        <h4>
          {{ $t("message.hello", {}, { locale: lang }) }}:
          <b id="usernamelogin">{{ usernamelogin }}</b>
        </h4>
        <h5><b>{{ $t("message.text1", {}, { locale: lang }) }}</b></h5>
        <br>
        <h5><b>{{ $t("message.text2", {}, { locale: lang }) }}</b></h5>
        <button class="btn btn-primary" id="pcgateway" v-on:click="gotoPCGateway">
          <h5>
            <b>{{ $t("message.text3", {}, { locale: lang }) }}</b>
          </h5>
          <p>{{ $t("message.text4", {}, { locale: lang }) }}</p>
        </button>
        <!-- <button class="btn btn-secondary" id="mobileapp">
          <h5>
            <b>{{ $t("message.text5", {}, { locale: lang }) }}</b>
          </h5>
          <p>{{ $t("message.text6", {}, { locale: lang }) }}</p>
        </button> -->
        <br><br><br>

        <input
        type="button"
        :value="$t('message.back', {}, { locale: lang })"
        class="btn btn-primary"
        v-on:click="back"
      />
      </div>
    </div>
  </div>
</template>

<script>
import callFunction, {
  logout,
} from "../../../public/common/vue/api/leanbot_js_api";
import $ from "jquery";
import WebsocketLeanbot from "../../../public/common/vue/api/leanbot.websocket";
import * as paho_mqtt from "paho-mqtt";
// import conf from "../../../public/config/vue/config.js";

export default {
  data() {
    return {
      lang: "en",
      usernamelogin: "",
    };
  },
  mounted() {
    this.usernamelogin = sessionStorage.getItem("USERNAME");
    if (sessionStorage.getItem("lang") == "vi") {
      this.lang = "vi";
    } else {
      this.lang = "en";
    }
  },
  methods:{
    gotoPCGateway(){
        window.open('/gateway', '_blank');
        window.location.href="/scandevice"
    },
    back(){
      history.back()
    },
  }
};
</script>
